<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="pagevii"></a><span class="small">CONTENTS</span></h1>
<p class="toc-preface" id="toc-ad-card"><a href="#/adcard">By the same author</a></p>
<p class="toc-preface" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-preface" id="toc-illustrations"><a href="#/illustrations">List of Illustrations</a></p>
<p class="toc-preface" id="toc-preface004"><a href="#/preface004">List of Maps</a></p>
<p class="toc-preface" id="toc-preface005"><a href="#/preface005">Family Tree</a></p>
<p class="toc-preface" id="toc-introduction"><a href="#/introduction">Introduction</a></p>
<p class="toc-chapter1" id="toc-chapter000"><a href="#/chapter000">1 The Emperor Menelik’s ‘New Flower’</a></p>
<p class="toc-chapter" id="toc-chapter001"><a href="#/chapter001">2 Hope and Fortune</a></p>
<p class="toc-chapter" id="toc-chapter002"><a href="#/chapter002">3 Gorgeous Barbarity</a></p>
<p class="toc-chapter" id="toc-chapter003"><a href="#/chapter003">4 ‘One Handsome Rajah’</a></p>
<p class="toc-chapter" id="toc-chapter004"><a href="#/chapter004">5 Passages to India and England</a></p>
<p class="toc-chapter" id="toc-chapter005"><a href="#/chapter005">6 The Cold, Bleak English Downs</a></p>
<p class="toc-chapter" id="toc-chapter006"><a href="#/chapter006">7 Eton: Lasting Respect and Veneration</a></p>
<p class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">8 Shrine of my Youth</span></p>
<p class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">9 The Mountains of Arussi</span></p>
<p class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">10 Across the Sultanate of Aussa</span></p>
<p class="toc-chapter" id="toc-chapter010"><span href="#/chapter010" title="Link target outside of Sample">11 Savage Sudan</span></p>
<p class="toc-chapter" id="toc-chapter011"><span href="#/chapter011" title="Link target outside of Sample">12 The Nuer</span></p>
<p class="toc-chapter" id="toc-chapter012"><span href="#/chapter012" title="Link target outside of Sample">13 Rape of my Homeland</span></p>
<p class="toc-chapter" id="toc-chapter013"><span href="#/chapter013" title="Link target outside of Sample">14 Among the Druze</span></p>
<p class="toc-chapter" id="toc-chapter014"><span href="#/chapter014" title="Link target outside of Sample">15 The Flowering Desert</span></p>
<p class="toc-chapter" id="toc-chapter015"><span href="#/chapter015" title="Link target outside of Sample">16 Palestine: Shifting Lights and Shades</span></p>
<p class="toc-chapter" id="toc-chapter016"><span href="#/chapter016" title="Link target outside of Sample">17 Prelude to Arabia</span></p>
<p class="toc-chapter" id="toc-chapter017"><span href="#/chapter017" title="Link target outside of Sample">18 Arabian Sands</span></p>
<p class="toc-chapter" id="toc-chapter018"><span href="#/chapter018" title="Link target outside of Sample">19 Marsh and Mountain</span></p>
<p class="toc-chapter" id="toc-chapter019"><span href="#/chapter019" title="Link target outside of Sample">20 Among the Mountains</span></p>
<p class="toc-chapter" id="toc-chapter020"><a id="pageviii"></a><span href="#/chapter020" title="Link target outside of Sample">21 A Winter in Copenhagen</span></p>
<p class="toc-chapter" id="toc-chapter021"><span href="#/chapter021" title="Link target outside of Sample">22 Camel Journeys to the Jade Sea</span></p>
<p class="toc-chapter" id="toc-chapter022"><span href="#/chapter022" title="Link target outside of Sample">23 With Nomadic Tribes in Other Lands</span></p>
<p class="toc-chapter" id="toc-chapter023"><span href="#/chapter023" title="Link target outside of Sample">24 Kenya Days</span></p>
<p class="toc-appendix1" id="toc-appendix001"><span href="#/appendix001" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc-appendix" id="toc-acknowledgements"><span href="#/acknowledgements" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc-appendix" id="toc-endnotes"><span href="#/endnotes" title="Link target outside of Sample">Notes</span></p>
<p class="toc-appendix" id="toc-bibliography"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc-appendix" id="toc-index"><span href="#/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?a36b412c